export default __webpack_public_path__ + "static/media/phcnEnu.ee3151cd.svg";